module.exports = __webpack_public_path__ + "media/images/where-assets-pisos-b-db66b88c4477eb02872d14638b301bc2.svg";